import CalendarIcon from "../../../Assests/icons/calendar.svg";
import DatePicker from "react-datepicker";


export default function DatePickerFilter({ dateRange, setDateRange }) {
    // Format date for display
    const formatDate = (date) =>
        date?.toLocaleDateString("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric",
    });

    return (
      <div className="datePickerWrapper">
        <DatePicker
            selectsRange
            startDate={dateRange[0]}
            endDate={dateRange[1]}
            onChange={(update) => setDateRange(update)} // Pass updated date range to parent
            dateFormat="MMM dd, yyyy"
            placeholderText="Select a date range"
            isClearable={false}
            showYearDropdown
            dropdownMode="select"
            yearDropdownItemNumber={10}
            scrollableYearDropdown
            minDate={new Date(2021, 0, 1)}
            maxDate={new Date()}
            customInput={
            <div className="custom-date-picker">
                <span>
                {dateRange[0] && dateRange[1]
                    ? `${formatDate(dateRange[0])} - ${formatDate(dateRange[1])}`
                    : "Select a date range"}
                </span>
                <img
                src={CalendarIcon}
                alt="Calendar"
                className="imageStyle"
                />
            </div>
            }
        />
    </div>
    )
}